/* eslint-disable react/jsx-props-no-spreading */
import { bool, string } from "prop-types";
import { BoltLightningSolidV6 } from "../../../../shared/v2/Icomoon";
import Tooltip from "../../../../shared/v2/Tooltip";

const TaskItemAssignedPlanIcon = ({ show, className, iconSize, planName, ...otherProps }) => {
  const size = iconSize || "m";

  if (!show) return null;

  const label = planName ? `Auto plan: ${planName}` : "Created by an auto plan";

  return (
    <Tooltip
      placement="top"
      trigger={
        <span className="tw-inline-flex tw-shrink-0" role="img" aria-label={label}>
          <BoltLightningSolidV6 size={size} className={className} {...otherProps} />
        </span>
      }
      content={label}
    />
  );
};

TaskItemAssignedPlanIcon.propTypes = {
  show: bool,
  iconSize: string,
  className: string,
  planName: string,
};

TaskItemAssignedPlanIcon.defaultProps = {
  iconSize: null,
  show: false,
  className: "",
  planName: null,
};

export default TaskItemAssignedPlanIcon;
